import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Footer } from "../../layouts/footer";
import { Trash } from "lucide-react";
import config from '../../../config';

const ManageCategory = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${config.baseURL}/categories`);
        const data = await response.json();

        if (Array.isArray(data)) {
          setCategories(data); // Only set if data is an array
        } else {
          console.error("Unexpected response format:", data);
          setCategories([]); // Reset to an empty array if response is invalid
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]); // Reset to an empty array in case of an error
      }
    };

    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
        "Are you sure you want to delete this category?"
    );
    if (!confirmDelete) return;

    try {
        const response = await fetch(`${config.baseURL}/delete_category/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include"  // If you're using sessions/cookies
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        if (data.status) {
            alert("Category deleted successfully");
            setCategories(categories.filter((category) => category.id !== id));
        } else {
            alert(data.message || "Failed to delete category");
        }
    } catch (error) {
        console.error("Error deleting category:", error);
        alert("An error occurred while deleting the category");
    }
};

  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="title">Category</h1>
      <div className="card">
        <div className="card-header flex justify-between">
          <p className="card-title">Product Category</p>
          {/* <NavLink
            to="/admin/addcategory"
            className="sidebar-item whitespace-nowrap"
          >
            Add Category
          </NavLink> */}
        </div>
        <div className="card-body p-0">
          <div className="relative h-[500px] w-full flex-shrink-0 overflow-auto rounded-none [scrollbar-width:_thin]">
            <table className="table">
              <thead className="table-header">
                <tr className="table-row">
                  <th className="table-head">Id</th>
                  <th className="table-head">Image</th>
                  <th className="table-head">Category Name</th>
                  <th className="table-head">Created at</th>
                  {/* <th className="table-head">Actions</th> */}
                </tr>
              </thead>
              <tbody className="table-body">
                {categories.length > 0 ? (
                  categories.map((category) => (
                    <tr key={category.id} className="table-row">
                      <td className="table-cell">{category.id}</td>
                      <td className="table-cell">
                        <div className="flex w-max gap-x-4">
                          <img
                            src={`${config.imageURL}/uploads/${category.image}`}
                            alt={category.catname}
                            className="size-14 rounded-lg object-cover"
                          />
                        </div>
                      </td>
                      <td className="table-cell">{category.catname}</td>
                      <td className="table-cell">
                        {new Date(category.created_at).toLocaleDateString()}
                      </td>
                      {/* <td className="table-cell">
                        <div className="flex items-center gap-x-4">
                          <button
                            className="text-red-500"
                            onClick={() => handleDelete(category.id)}
                          >
                            <Trash size={20} />
                          </button>
                        </div>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No categories found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ManageCategory;
